<template>
    <v-snackbar
      v-model="snackbar.ativo"
      :multi-line="snackbar.mode === 'multi-line'"
      :timeout="snackbar.timeout"
      :top="snackbar.y === 'top'"
      :right="true"
      :vertical="snackbar.mode === 'vertical'"
      :color="snackbar.tipo"
    >
      {{ snackbar.texto }}
      <v-btn
        v-if="snackbar.ativarFechado"
        flat
        @click="fecharSnackbar()"
      >
        X
      </v-btn>
    </v-snackbar>
</template>
<script>
import { mapState } from 'vuex'

export default {
    computed: {
        ...mapState({
            snackbar: state => state.snackbar,
        })
    },
    methods: {
        fecharSnackbar(){
            this.$store.commit('fecharSnackbar');
        }
    }

}
</script>